import { useEffect, useState } from "react";
import { ventilacionSectors } from "@/mocks/serviceVentilacionData";
import { AnimTiltedCard } from "@readdy/anim/card/tilted-card/react";

export default function VentilacionSectors() {
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReducedMotion(mq.matches);
    const onChange = (e: MediaQueryListEvent) => setReducedMotion(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="reveal text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0087a4] mb-3 block">
            Sectores
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            Soluciones para diferentes sectores
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {ventilacionSectors.map((sector, i) => {
            const card = (
              <div
                className="reveal relative h-[220px] md:h-[260px] rounded-lg overflow-hidden group"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <img
                  src={sector.image}
                  alt={`Sistemas de ventilación mecánica para el sector ${sector.name.toLowerCase()}`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/35 to-foreground-950/10 group-hover:from-foreground-950/90 transition-all duration-500" />
                <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                  <div className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-[#0087a4] shrink-0" />
                    <h3 className="font-heading font-bold text-background-50 text-base md:text-lg leading-tight">
                      {sector.name}
                    </h3>
                  </div>
                </div>
              </div>
            );

            return reducedMotion ? (
              <div key={sector.name} className="contents">
                {card}
              </div>
            ) : (
              <AnimTiltedCard key={sector.name} maxTilt={12} strength={0.08}>
                {card}
              </AnimTiltedCard>
            );
          })}
        </div>
      </div>
    </section>
  );
}